import axios from 'axios'
import NProgress from 'nprogress' // progress bar
import website from '@/config/website'
import 'nprogress/nprogress.css'
axios.defaults.timeout = 30000
axios.defaults.baseURL=website.apiURL;
// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
// axios.defaults.withCredentials = true
// NProgress Configuration
NProgress.configure({
  showSpinner: false
})

// HTTPrequest拦截
axios.interceptors.request.use(
  config => {
    NProgress.start() // start progress bar

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// HTTPresponse拦截
axios.interceptors.response.use(
  res => {
    NProgress.done()

    return res
  },
  error => {
    NProgress.done()
    return Promise.reject(new Error(error))
  }
)

export default axios
